var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{staticClass:"justify-start mt-5"},_vm._l((_vm.tags),function(item,index){return _c('v-col',{key:index,attrs:{"cols":"4"}},[_c('tag',{staticClass:"flex-grow-1",attrs:{"item":item}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }